export const STATIC_CLASSES = Object.freeze({
	root: 'video4',
	videoContainer: 'video4-video-block',
	video: 'video4-video',
	textContainer: 'video4-container',
	content: 'video4-content',
	text: 'video4-text-block',
	buttonContainer: 'video4--button-wrapper',
	button: 'video4-button',
})
